module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAAECAYAAABhlOHEAAAAWElEQVRYR2P8m5v8n4ECwDx5LiM+7aPmj4YPvvQxmn7wZz5ahw/jaAYdzaCjGZT8GpDWGZTW5o8WAKMtGLypn9YJcNT80RbAaAIkvwJiGM1AA5uBhnr4AwBtaqs1SxEMOwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/underline_2x.png
// module id = 6Cb/
// module chunks = 1